export default "__VITE_ASSET__c0b64925__"